import * as React from 'react';
import './SpinningTick.scss';
import { childClassClosure } from "@jcharlesworthuk/your-mum-core/dist/functions";

const baseClass = 'spinning-tick';
const childClass = childClassClosure(baseClass);


type Props = {
    isLoading: boolean;
    invertColours?: boolean;
}

const SpinningTick: React.FunctionComponent<Props> = (props) => {
    return <div className={`${baseClass} ${props.isLoading || 'load-complete'} ${props.invertColours ? baseClass + '--inverse' : ''}`}>
        <div className={childClass('checkmark', props.isLoading ? '' : 'show-tick', props.invertColours ? 'inverse' : '')}></div>
    </div>
}

export default SpinningTick;